// extracted by mini-css-extract-plugin
export var copyableField = "_mk-4";
export var customerBadge = "_mk-0";
export var customerInfoTitle = "_mk-2";
export var details = "_mk-1";
export var dropdownContainer = "_mk-5";
export var dropdownImage = "_mk-6";
export var editAssigneeForm = "_mk-a";
export var editButton = "_mk-3";
export var email = "_mk-7";
export var hidden = "_mk-d";
export var input = "_mk-8";
export var saveButton = "_mk-b";
export var shopifyIcon = "_mk-c";
export var suggestionBadge = "_mk-e";
export var suggestionText = "_mk-f";
export var username = "_mk-9";